<template>
  <b-form @submit="onSubmit">
    <b-form-group
      id="input-group-name"
      label="Nom"
      label-for="input-name">
      <b-form-input
        id="input-name"
        v-model="form.quiz_name"
        type="text"
        placeholder="Exemple : Grands classiques"
        required
        @update="toRefresh()"
      />
    </b-form-group>
    <b-form-group
      id="input-group-category"
      label="Catégorie"
      label-for="input-category">
      <b-form-select
        v-model="form.quiz_category"
        :options="categoriesValues"
        @change="toRefresh()"
        />
    </b-form-group>
    <b-form-group
      id="input-group-level"
      label="Niveau de difficulté"
      label-for="input-level">
      <b-form-select
        v-model="form.quiz_level"
        :options="levelValues"
        @change="toRefresh()"
        />
    </b-form-group>
    <div
      v-for="(question, index) in form.questions"
      :key="'q'+index"
      class="form_questions">
      <b-row>
        <b-col>
          <b-form-group
            :id="`input-group-question${index}`"
            :label-for="`input-question${index}`"
            :label="`Question ${index + 1}`">
            <b-form-textarea
              :id="`input-question${index}`"
              v-model="form.questions[index].question"
              type="text"
              maxlength="125"
              placeholder="Exemple : Quel jour sommes-nous ?"
              required
              @update="toRefresh()"
            />
            <div class="text-right">{{
              `${form.questions[index].question.length}
               / 125 caractères restants` }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            :id="`input-group-answer${index}`"
            :label-for="`input-answer${index}`"
            label="Réponse attendue">
            <b-form-input
              :id="`input-answer${index}`"
              v-model="form.questions[index].answer"
              placeholder="Exemple : Lundi"
              type="text"
              required
              @update="toRefresh()"
            />
        </b-form-group></b-col>
        <b-col>
          <b-form-group
            :id="`input-group-false1${index}`"
            :label-for="`index-false1${index}`"
            label="Mauvaise réponse 1">
            <b-form-input
              :id="`index-false1${index}`"
              v-model="form.questions[index].false_1"
              type="text"
              placeholder="Exemple : Septembre"
              required
              @update="toRefresh()"
            />
        </b-form-group></b-col>
        <b-col>
          <b-form-group
            :id="`input-group-false2${index}`"
            :label-for="`index-false2${index}`"
            label="Mauvaise réponse 2">
            <b-form-input
              :id="`index-false2${index}`"
              v-model="form.questions[index].false_2"
              type="text"
              placeholder="Exemple : En 2021"
              required
              @update="toRefresh()"
            />
        </b-form-group></b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            :id="`input-group-explanation${index}`"
            :label-for="`input-explanation${index}`"
            label="Explication">
            <b-form-textarea
              :id="`input-explanation${index}`"
              v-model="form.questions[index].explanation"
              type="text"
              maxlength="550"
              placeholder="Exemple : Le premier jour du reste de ta vie. C'est un matin comme tous les autres. Un nouveau pari. Rechercher un peu de magie dans cette inertie morose."
              required
              @update="toRefresh()"
            />
            <div class="text-right">{{
              `${form.questions[index].explanation.length + (form.questions[index].explanation.match(/\n\n/g) || []).length * 55}
               / 550 caractères restants` }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Image">
            <b-form-file
              v-model="form.questions[index].img"
              :state="Boolean(form.questions[index].img)"
              placeholder="Choisissez un fichier ou déposez-le ici..."
              drop-placeholder="Déposez-le ici..."
              @update="change()"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div
            v-if="form.questions[index].img"
            class="mt-3">
            Fichier sélectionné: {{ form.questions[index].img ? form.questions[index].img.name : '' }}
          </div>
        </b-col>
      </b-row>
    </div>
    <b-row/>
    <b-row>
      <b-col class="text-center">
        <b-button
          :disabled="pending"
          type="submit"
          variant="primary">
          <span v-if="pending">
            <b-spinner
              small
              variant="light"/>
          </span>
          <span v-else>
            Enregistrer
          </span>
        </b-button>
      </b-col>
    </b-row>

  </b-form>
</template>

<script>
import { Refresh } from '../../services/global';
export default {
  name: 'FormQuiz',
  props: {
  },
  data() {
    return {
      form: {
        quiz_id: null,
        quiz_name: '',
        quiz_level: null,
        quiz_category: null,
        questions: [
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
          {
            question: '', anwser: null, false_1: null, false_2: null, explanation: '', img: null,
          },
        ],
      },
      categoriesValues: [{ value: 'art', text: 'Arts et Culture' },
        { value: 'gastronomy', text: 'Gastronomie' },
        { value: 'sport', text: 'Sport et loisirs' },
        { value: 'entertainment', text: 'Divertissement' },
        { value: 'science', text: 'Sciences' },
        { value: 'history', text: 'Histoire' },
        { value: 'geography', text: 'Géographie' }],
      levelValues: [{ value: 1, text: 'Facile' },
        { value: 2, text: 'Moyen' },
        { value: 3, text: 'Difficile' },
        { value: 4, text: 'Expert' }],
      pending: false,
    };
  },
  watch: {

  },
  mounted() {
  },
  methods: {
    async toRefresh(){
      // appel RefreshToken pour maintenir le token lors de la saisie qui peut être longue
      await Refresh();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.pending = true;
      const formData = new FormData();
      const files = this.form.questions.map(e => e.img);
      for (let i = 0; i < files.length; i += 1) {
        const file = files[i];
        formData.append(`files[${i}]`, file);
      }
      formData.append('quiz_name', this.form.quiz_name);
      formData.append('quiz_level', this.form.quiz_level);
      formData.append('quiz_category', this.form.quiz_category);
      formData.append('questions', JSON.stringify(this.form.questions));
      this.$store.dispatch('modules/setMiniQuiz', formData).then(() => {
        this.pending = false;
        this.$emit('quizCreated');
      });
    },
  },
};
</script>

<style scoped>
.form_questions {
  padding: 10px;
  background-color: aliceblue;
  border-radius: 10px;
  border: 1px solid rgb(0 123 255 / 50%);
  margin: 10px 0;
}
</style>
